import React, { forwardRef } from 'react';
import Form from 'rsuite/Form';
import Toggle from 'rsuite/Toggle';

const FieldCheckbox = forwardRef((props, ref) => {
  const {
    name,
    required,
    ...rest
  } = props;
  return (
    <Form.Group controlId={name} ref={ref} className="field">
      <Form.Control
        name={name}
        accepter={Toggle}
        {...rest}
      />
    </Form.Group>
  );
})

export default FieldCheckbox;
